import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initConsentDefaults } from '@/lib/consent'

// Initialize consent defaults before any scripts load
initConsentDefaults();

createRoot(document.getElementById("root")!).render(<App />);
